import React from "react";

import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FileSelect from './FileSelect';
import { basisOptions, monthOptions } from './options';

export default function ForexConverter({ currOptions, defaultValue }) {
//console.log("ForexConverter");

    const [focurrency, setFoCurrency] = React.useState(currOptions[defaultValue].value);
    const [fucurrency, setFuCurrency] = React.useState(currOptions[defaultValue].value);
    const [basis, setBasis] = React.useState(basisOptions[0].value);
    const [month, setMonth] = React.useState(0);
    const [basisObj, setBasisObj] = React.useState('');

    const handleFoCurrency = (event) => {
        //console.log('FoCurrency')
        setFoCurrency(event.target.value);
    };

    const handleFuCurrency = (event) => {
        //console.log('FuCurrency')
        setFuCurrency(event.target.value);
    };

    const handleBasis = (event) => {
        if (event.target.value === 'Financial year') {
            document.getElementById("month-end-visibility").style.visibility = "visible";
        } else {
            document.getElementById("month-end-visibility").style.visibility = "hidden";
        }
        setBasis(event.target.value);
    };

    const handleMonth = (event) => {
        setMonth(event.target.value);
    };

    React.useEffect(() => {
        // console.log("Running render");
        let bObj = {
            'basis': basis,
            'period': [],
            'yearend': month,
            'foreign_currency': focurrency,
            'functional_currency': fucurrency,
            'date_format': 0
        };
        setBasisObj(bObj)
    }, [basis, focurrency, fucurrency, month]);

    return (
        <React.Fragment>
            <Grid item xs={12} sx={{ mt: 2 }}>
                <InputLabel sx={{ fontSize: 18, fontWeight: 'bold' }}>Realised FX Calculator</InputLabel>
            </Grid>
            <Grid item xs={2}>
                <FormControl fullWidth >
                <InputLabel sx={{ pt: 0.1, pb: 0.1 }} id="focurrency-label">Foreign currency</InputLabel>
                    <Select
                        labelId="focurrency-label"
                        label="Foreign Currency"
                        name="ForeignCurrency"
                        id="foreign-currency"
                        size="small"
                        value={focurrency}
                        onChange={handleFoCurrency}
                    >
                        {currOptions.map((fcurrency) => (
                            <MenuItem key={fcurrency.value} value={fcurrency.value}>
                                {fcurrency.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={2}>
                <FormControl fullWidth >
                <InputLabel sx={{ pt: 0.1, pb: 0.1 }} id="fucurrency-label">Functional currency</InputLabel>
                    <Select
                        labelId="fucurrency-label"
                        label="Functional Currency"
                        name="functionalCurrency"
                        id="functional-currency"
                        size="small"
                        value={fucurrency}
                        onChange={handleFuCurrency}
                    >
                        {currOptions.map((fcurrency) => (
                            <MenuItem key={fcurrency.value} value={fcurrency.value}>
                                {fcurrency.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={3}>
                <FormControl fullWidth >
                    <InputLabel sx={{ pt: 0.1, pb: 0.1 }} id="basis-label">Basis</InputLabel>
                    <Select
                        labelId="basis-label"
                        label="Basis"
                        name="basis"
                        id="basis"
                        size="small"
                        value={basis}
                        onChange={handleBasis}
                    >
                        {basisOptions.map((basis) => (
                            <MenuItem key={basis.value} value={basis.value}>
                                {basis.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item id="month-end-visibility" xs={2} sx={{ visibility: 'hidden' }}>
                <FormControl fullWidth >
                    <InputLabel sx={{ pt: 0.1, pb: 0.1 }} id="month-end-label">Month end</InputLabel>
                    <Select
                        labelId="month-end-label"
                        label="Month end"
                        name="monthEnd"
                        id="month-end-id"
                        size="small"
                        value={month}
                        onChange={handleMonth}
                    >
                        {monthOptions.map((month) => (
                            <MenuItem key={month.value} value={month.value}>
                                {month.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={2}></Grid>
            <FileSelect basisObj={basisObj} />
        </React.Fragment>
    )
};
